import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';
import { GoPerson } from '@react-icons/all-files/go/GoPerson';
import { GoX } from '@react-icons/all-files/go/GoX';
import { useTranslation } from 'react-i18next';
import { LoginData } from '../../../util/LoginData';

export const UserMenu = () => {
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const { t } = useTranslation();
  const { authenticated, username, logout: sessionLogout } = LoginData();

  if (!authenticated) return null;

  const handleUserMenuOpen = (event) => {
    setUserMenuAnchor(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchor(null);
  };

  const logout = () => {
    sessionLogout();
  };

  const close = () => {
    handleUserMenuClose();
  };

  return (
    <>
      <IconButton
        aria-label="open user menu"
        aria-controls={userMenuAnchor ? 'user-menu' : undefined}
        aria-haspopup="true"
        onClick={handleUserMenuOpen}
        style={{ color: '#6f89a6' }}
      >
        <GoPerson />
      </IconButton>
      <Popover
        id="user-menu"
        anchorEl={userMenuAnchor}
        keepMounted
        open={Boolean(userMenuAnchor)}
        onClose={handleUserMenuClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          style: {
            backgroundColor: '#1c2429',
            color: '#cfd2d4',
            marginTop: -4,
            border: '1px solid #3F5665',
            position: 'relative',
            width: 'max-content',
            minWidth: 180,
            maxWidth: 'calc(100vw - 16px)',
            overflow: 'visible',
          },
        }}
      >
        <IconButton
          aria-label={t('close')}
          onClick={close}
          style={{
            color: '#cfd2d4',
            padding: 4,
            position: 'absolute',
            right: -12,
            top: -12,
            zIndex: 1,
            overflow: 'visible',
          }}
        >
          <GoX />
        </IconButton>
        <div style={{ paddingBottom: 6 }}>
          <MenuItem
            disabled
            style={{
              color: '#cfd2d4',
              opacity: 1,
              justifyContent: 'flex-end',
              textAlign: 'right',
              whiteSpace: 'nowrap',
            }}
          >
            {username}
          </MenuItem>
          <MenuItem
            onClick={logout}
            style={{
              backgroundColor: '#273541',
              justifyContent: 'flex-end',
              textAlign: 'right',
            }}
          >
            {t('logout')}
          </MenuItem>
        </div>
      </Popover>
    </>
  );
};

export default UserMenu;
